'use strict';
var React = require('react');
var ReactDOM = require('react-dom');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var i18nHelper = require('../../helper/i18n');
var storeHelper = require('../../helper/storeHelper');
var appTypes = require('../../types/appTypes');

var StylePicker = require('./StylePicker.jsx');
var SaveAlert = require('./SaveAlert.jsx');
var ProcessAlert = require('./ProcessAlert.jsx');
var SignCheckAlert = require('./SignCheckAlert.jsx');
var PaintToolbar = require('./PaintToolbar');

var graphicsHelper = require('../../helper/graphicsHelper');

var Mediator = require('../../helper/Review/Mediator');
var Opreations = require('../../helper/Review/PaintOpreations');
var Events = require('../../helper/Review/PaintEvents');
var LayerManager = require('../../helper/Review/LayerManager');
var Data = require('../../helper/Review/PaintData');
var Tool = require('../../helper/Review/PaintTool');
var InputText = require('../../helper/Review/InputText');
var ErrorMessage = require('../ErrorMessage');

var BUTTON_KEY = {
  'PENCIL': 'pencil', 'RECT': 'rect', 'ARROW': 'arrow', 'ARC': 'arc',
  'TEXT': 'text', 'MOUSE': 'mouse'
};

var CommentTool = React.createClass({

  propTypes: {
    page: React.PropTypes.object.isRequired,
    deviceScrollStyle: React.PropTypes.object.isRequired,
    review: React.PropTypes.object.isRequired,
    onExitPaint: React.PropTypes.func.isRequired,
    onAddReview: React.PropTypes.func.isRequired,
    onUpdateReview: React.PropTypes.func.isRequired,
    onRemoveReview: React.PropTypes.func.isRequired,
    fullPageLocation: React.PropTypes.object.isRequired,
    sign: React.PropTypes.func.isRequired,
    isSign: React.PropTypes.bool.isRequired,
    onError: React.PropTypes.func.isRequired,
    onClearError: React.PropTypes.func.isRequired,
    syncID: React.PropTypes.string.isRequired,
    syncVersion: React.PropTypes.string.isRequired,
    ID: React.PropTypes.string.isRequired,
  },

  getInitialState: function () {
    return {
      checkedKey: BUTTON_KEY.MOUSE,
      isShowStylePicker: false,
      checkedTool: 'ArrowTool',
      isShowSaveAlert: false,
      isVisible: true,
      update: true,
      isBackColor: false,
      isSaveError: false,
      saveErrMsg: '',
      saveDisabled: true,
      undoDisabled: true,
      redoDisabled: true,
      onExit: false,
      isToolbarMountDone: false,
      location: null,

      cursor: 'crosshair',
    };
  },

  canvas: null,

  componentWillMount: function() {
    //初始化
    Mediator.init(this, Opreations, Events, LayerManager, Data, Tool, InputText);
    Data.isSaved = true;
    this.checkData();
  },
  componentDidMount: function () {
    this.canvas = ReactDOM.findDOMNode(this.refs.canvas);
    Mediator.initEvents(this.state.checkedTool);
    Mediator.setVisible(this.state.isVisible);
    Tool.initStyle();
  },
  cursorStyle: null,
  componentWillUpdate: function() {
    this.cursorStyle = this.canvas.style.cursor;
    this.checkData();
  },
  componentDidUpdate: function() {
    if(this.props.fullPageLocation) {
      Data.loadData2();
    }
    this.canvas.style.cursor = this.cursorStyle;
    Mediator.setVisible(this.state.isVisible);
  },

  componentWillUnmount: function() {
    Data.currentState = null;
  },

  catchError: false,
  checkData: function() {
    if(storeHelper.get('netState') === 'failed') {
      storeHelper.set('netState', 'init');
      storeHelper.set('loadState', 'init');
      this.props.onError(i18nHelper.get('NET_ERROR'), this.onClearNetError);
    }
    if(storeHelper.get('loadState') === 'failed') {
      storeHelper.set('loadState', 'init');
      this.props.onError(i18nHelper.get('LOAD_REVIEW_FAILED'));
    }

    Data.handleSave2();
    //在已经加载目标页面的情况下。加载数据
    if(this.props.fullPageLocation) {
      Data.loadData2();
    }
    Data.initStates();

    //当前处于退出批注状态，全部数据保存完毕，且无保存失败数据
    if(this.state.onExit && Data.saveDone && Data.saveSuccess) {
      this.props.onExitPaint();
    }
    if(!Data.saveSuccess && !this.catchError) {     //有数据保存失败，且未被用户确认
      this.props.onError(Data.saveErrMsg, this.onClearError);
      this.catchError = true;
    }
  },

  render: function () {
    var page = this.props.page;
    var saveSuccess = storeHelper.get('saveSuccess');
    var className = 'commentMode-popWindow';
    var canvasStyle = {cursor: this.state.cursor};
    return (
      <div className={className} style={this.props.deviceScrollStyle}>
        <PaintToolbar
            page={page}
            onMouseClick={this.changeToMouse}
            onRectangleClick={this.changeToRect}
            onFilledRectangleClick={this.changeToFilledRect}
            onEllipseClick={this.changeToArc}
            onFilledEllipseClick={this.changeToFilledArc}
            onArrowClick={this.changeToArrow}
            onPencilClick={this.changeToPencil}
            onTextClick={this.changeToText}
            onSaveClick={this.save}
            onUndoClick={this.rollBack}
            onRedoClick={this.reRollBack}
            onDeleteClick={this.deleteLayer}
            onHiddenClick={this.hidden}
            onClearClick={this.clearSelf}
            onExitClick={this.exit}
            checkTool={this.state.checkedTool}
            saveDisabled={!Data.isSavable()}
            undoDisabled={!Data.isUndoable()}
            redoDisabled={!Data.isRedoable()}
            isVisible={this.state.isVisible}
            isClearable={Mediator.isClearable()}
            onToolbarMountDone={this.onToolbarMountDone}
        />
        <form>
          <textArea ref='text' className='input-text' onChange={this.handleChange}/>
        </form>
        <div>
          <canvas ref="canvas"
                  width={this.props.deviceScrollStyle.width}
                  height={this.props.deviceScrollStyle.height}
                  style={canvasStyle}
          ></canvas>
        </div>
        {this.state.isShowStylePicker && this.state.isToolbarMountDone &&
        <StylePicker
            checkedTool={this.state.checkedTool}
            colorChecked={this.colorChecked}
            backColorChecked={this.backColorChecked}
            backAlphaCheck={this.backAlphaCheck}
            lineWidthChecked={this.lineWidthChecked}
            fontSizeChecked={this.fontSizeChecked}
            isBackColor={this.state.isBackColor}
            switchToFront={this.switchToFront}
            switchToBack={this.switchToBack}
            location={this.state.location}
        />}
        {!this.props.isSign &&
        <SignCheckAlert
            registKeyEvent={Mediator.registKeyEvent}
            onExitPaint={this.props.onExitPaint}
            sign={this.props.sign}
        /> }
        {this.state.isShowSaveAlert &&
        <SaveAlert
            registKeyEvent={Mediator.registKeyEvent}
            onDismissSaveAlert={this.onDismissSaveAlert}
            onSave={this.onSave}
        />}
        {!Data.saveDone &&
        <ProcessAlert
            max={Data.saveTotal}
            value={Data.doneNum}
        />}
        {storeHelper.get('loadState') === 'wait' &&
          <div className='pop-alert-cover'>
            <div className='pop-alert'>
              <span className='loading'>{i18nHelper.get('REVIEW_LOADING')}</span>
            </div>
          </div>
        }
      </div>
    )
  },

  handleChange: function(event) {
    var text = event.target.value;
    Mediator.adapteText(text);
  },

  update: function() {
    this.setState({update: !this.state.update});
  },

  switchToFront: function() {
    this.setState({isBackColor: false});
  },

  switchToBack: function() {
    this.setState({isBackColor: true});
  },
  colorChecked: function(value) {
    var key = this.state.checkedTool;
    Tool.setStyle(key, 'color', value);
    this.update();
  },
  backColorChecked: function(value) {
    var key = this.state.checkedTool;
    Tool.setStyle(key, 'backColor', value);
    this.update();
  },
  backAlphaCheck: function(value) {
    var key = this.state.checkedTool;
    Tool.setStyle(key, 'backColorAlpha', value/100);
    this.setState({backAlpha: value});
  },
  lineWidthChecked: function(value) {
    var key = this.state.checkedTool;
    Tool.setStyle(key, 'strokeWidth', value);
    this.update();
  },
  fontSizeChecked: function(value) {
    var key = this.state.checkedTool;
    Tool.setStyle(key, 'fontSize', value);
    this.update();
  },
  onDismissSaveAlert: function () {
    this.setState({isShowSaveAlert: false});
  },
  onClearError: function() {
    //重置默认值
    this.catchError = false;
    Data.saveSuccess = true;
    Data.saveErrMsg = '';
    this.props.onClearError();
  },
  onClearNetError: function() {
    storeHelper.get('netState') === 'init';
    this.props.onExitPaint();
    this.props.onClearError();
  },
  deleteLayer: function () {
    Mediator.deleteLayer();
    this.setState({isShowStylePicker: false});
  },
  hidden: function() {
    this.setState({isShowStylePicker: false,isVisible: !this.state.isVisible});
  },
  clearSelf: function() {
    Mediator.clearSelf();
  },
  rollBack: function () {
    if(!Data.isUndoable()) {
      return;
    }
    Data.rollBack2();
    this.setState({isShowStylePicker: false, update: !this.state.update});
  },
  reRollBack: function () {
    if(!Data.isRedoable()) {
      return;
    }
    Data.reRollBack2();
    this.setState({isShowStylePicker: false, update: !this.state.update});
  },
  onSave: function(isSave) {
    if(isSave) {
      Data.startSave2(true);
      this.setState({isShowSaveAlert: false, onExit: true});
    } else {
      Data.clearLocal();
      this.props.onExitPaint();
    }
  },
  save: function() {
    if(!Data.isSavable()) {
      return;
    }
    Data.startSave2();
    this.setState({isShowStylePicker: false});
  },
  exit: function () {
    if (Data.isSavable()) {
      this.setState({isShowSaveAlert: true});
    } else {
      this.props.onExitPaint();
    }
  },

  onToolbarMountDone: function(location) {
    if(location) {
      this.setState({isToolbarMountDone: true, location: location});
    }
  },
  changeToRect: function (e) {
    Mediator.reset();
    Mediator.initEvents('RectTool');
    this.setState({isShowStylePicker: true, checkedTool: 'RectTool', isVisible: true});
  },
  changeToFilledRect: function() {
    Mediator.reset();
    Mediator.initEvents('FilledRectTool');
    this.setState({isShowStylePicker: true, checkedTool: 'FilledRectTool', isVisible: true});
  },
  changeToPencil: function () {
    Mediator.reset();
    Mediator.initEvents('PencilTool');
    this.setState({isShowStylePicker: true, checkedTool: 'PencilTool', isVisible: true});
  },
  changeToArrow: function () {
    Mediator.reset();
    Mediator.initEvents('ArrowTool');
    this.setState({isShowStylePicker: true, checkedTool: 'ArrowTool', isVisible: true});
  },
  changeToArc: function () {
    Mediator.reset();
    Mediator.initEvents('EllipseTool');
    this.setState({isShowStylePicker: true, checkedTool: 'EllipseTool', isVisible: true});
  },
  changeToFilledArc: function() {
    Mediator.reset();
    Mediator.initEvents('FilledEllipseTool');
    this.setState({isShowStylePicker: true, checkedTool: 'FilledEllipseTool', isVisible: true});
  },
  changeToText: function () {
    Mediator.reset();
    Mediator.initEvents('TextTool');
    this.setState({isShowStylePicker: true, checkedTool: 'TextTool', isVisible: true});
  },
  changeToMouse: function () {
    Mediator.reset();
    Mediator.initEvents('MouseTool');
    this.setState({isShowStylePicker: false,checkedTool: 'MouseTool', isVisible: true});
  },
});

module.exports = CommentTool;



// WEBPACK FOOTER //
// ./src/views/Review/CommentTool.jsx